import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {NotFoundComponent} from "./shared";

const routes: Routes = [


  {
    path: "",
    loadChildren:
      "./portal/portal.module#PortalModule"
  },
  // {
  //   path: "patient-portal",
  //   loadChildren: "./patient-portal/patient-portal.module#PatientPortalModule"
  // },
  {
    path: "not-found",
    component: NotFoundComponent
  },
  {path: "**", redirectTo: "not-found"}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/app-routing.module.ts